import { PortalContext } from "../../../../context/Provider";
import React, { useEffect, useContext, useState } from "react";
import CardTemplate from "../../../Genericos/CardTemplate/CardTemplate";
import BotonToggle from "../../../Genericos/BotonToggle/BotonToggle";
import "./CardNotificaciones.css";

const CardNotificaciones = ({ onClickAceptaWsp }) => {
  const { pacienteState, textosState } = useContext(PortalContext);

  return (
    <React.Fragment>
      <CardTemplate
        tituloCard="Mis notificaciones"
        bodyCard={
          <div className="ptur-card-perfil-body-notificaciones">
            <div className="ptur-card-perfil-body-notificaciones-columna1-fila1">
              <h3 className="ptur-card-perfil-body-notificaciones-texto rb16t c-grey45">
                {textosState.textos.data
                  ? textosState.textos.data.txtAceptaWhatsapp.descripcion
                  : ""}
              </h3>
            </div>
            <div className="ptur-card-perfil-body-notificaciones-columna2-fila1">
              <BotonToggle
                onClickAceptaWsp={onClickAceptaWsp}
                wspVinculado={
                  pacienteState.paciente.datosActualizados.aceptaAlertaWapp
                }
                active={ pacienteState.paciente.datosActualizados.aceptaAlertaWapp}
                altStr="aceptaWsp"
              />
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

export default CardNotificaciones;
